var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Pagination from "../../common/components/Pagination";
import { Loading } from 'element-ui';
import { mapGetters, mapActions } from "vuex";
import PowerAuthManageService from "../../api/PowerAuthManageService";
import CommonService from "../../api/CommonService";
import GlobalVue from "../../globalVue";
import { EBillType } from "../../enum/EBillType";
import { billDefaultDate } from "../../helper/defaultDate";
import { EPurSortingStatus } from "../../enum/EStatus";
import AreaShop from "@/components/AreaShop";
import Auth from '../user/Auth.vue';
import UserList from '../user/List.vue';
function getDefaultFormData() {
    return {
        text: "",
        dateType: "1",
        s_time: billDefaultDate().Start.format('yyyy-MM-dd'),
        e_time: billDefaultDate().End.format('yyyy-MM-dd'),
        rechargeStatus: -1,
        shop: null,
        rechargeType: -1
    };
}
function tidyDepotList(treeData) {
    treeData.forEach(function (item) {
        if (item.organ_id && !item.depot_id) {
            item.isDisabled = true;
            item.depot_id = "organ_id_" + item.organ_id;
            item.depot_name = item.organ_name;
        }
        if (item.children && item.children.length) {
            tidyDepotList(item.children);
        }
    });
}
var PurSorting = (function (_super) {
    __extends(PurSorting, _super);
    function PurSorting() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = getDefaultFormData();
        _this.statusList = [];
        _this.tableData = [];
        _this.selectedData = [];
        _this.tableHeight = 0;
        _this.total = 0;
        _this.eBillType = EBillType;
        _this.ePurSortingStatus = EPurSortingStatus;
        _this.dialogVisible = false;
        _this.exportType = "1";
        _this.isMoreSearch = false;
        _this.dateTypeList = [{ name: "创建日期", id: "1" }, { name: "审核日期", id: "2" }, { name: "废弃日期", id: "3" }];
        _this.depotList = [];
        _this.exportDetail = {};
        _this.importTypeList = [
            { id: 1, name: '分拣导出-门店分拣' },
            { id: 2, name: '分拣导出-货品分拣' }
        ];
        _this.importType = 1;
        _this.dialogTableVisible = false;
        _this.importSuccessNum = 0;
        _this.importFailnum = 0;
        _this.befordImport = true;
        _this.importting = false;
        _this.afterImport = false;
        _this.failDownLoadUrl = "";
        _this.responseSuccess = false;
        _this.responseFail = false;
        _this.errorMsg = "";
        _this.organBusiness = [];
        _this.rechargeTypeList = [
            {
                id: -1,
                name: "全部"
            },
            {
                id: 1,
                name: "手动充值"
            },
            {
                id: 2,
                name: "手动扣款"
            },
            {
                id: 3,
                name: "退款充值"
            },
        ];
        _this.rechargeStatusList = [
            {
                id: -1,
                name: "全部"
            },
            {
                id: 0,
                name: "待审核"
            },
            {
                id: 1,
                name: "已审核"
            },
        ];
        _this.handleRecharge = false;
        _this.handleDeduction = false;
        _this.handleEdit = false;
        _this.deductionForm = {
            powerName: "",
            remark: "",
        };
        _this.formLabelWidth = '100px';
        _this.deductionFormRules = {
            powerName: [
                { required: true, message: '请输入岗位名称', trigger: 'change' },
            ],
        };
        _this.rowData = null;
        _this.dialogTitle = "";
        return _this;
    }
    PurSorting.prototype.created = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.$el && _this.$el.parentElement) {
                _this.tableHeight = _this.$el.parentElement.clientHeight - 120;
            }
        }, 300);
        this.service = PowerAuthManageService.getInstance();
        this.commonService = CommonService.getInstance();
    };
    PurSorting.prototype.mounted = function () {
        this.getList();
    };
    PurSorting.prototype.delRole = function () {
        var _this = this;
        var selected = this.selectedData || [];
        if (!selected.length) {
            return this.$message.warning('请先选择岗位数据');
        }
        var params = {
            supplier_role_id: selected.map(function (item) { return item.supplier_role_id; }).join(',')
        };
        var handleErr = function (res) {
            var h = _this.$createElement;
            _this.$msgbox({
                title: '提示',
                message: h('div', null, [
                    h('p', null, res.data.msg),
                    h('p', null, [
                        h('span', {
                            style: {
                                margin: '0'
                            }
                        }, '请先调整用户账号的岗位后再执行删除，'),
                        h('a', {
                            on: {
                                click: function () {
                                    console.log('调整>>>', _this.$msgbox);
                                    _this.$msgbox.close();
                                    var menu = {
                                        power_code: '6003'
                                    };
                                    _this.getAuth(menu.power_code).then(function (pageAuth) {
                                        menu = !menu.power_id ? pageAuth.Response : menu;
                                        console.log('getAuth>>>', menu);
                                        GlobalVue.$emit("addTab", {
                                            component: UserList,
                                            title: '用户管理',
                                            name: menu.power_id,
                                            showExist: true,
                                            cprops: __assign({}, menu, { Root_PageAuth: pageAuth && pageAuth.Auth, root_PageAuth$$: pageAuth && pageAuth.Auth })
                                        });
                                    });
                                }
                            },
                            style: {
                                'cursor': 'pointer'
                            }
                        }, '前往调整>>')
                    ])
                ]),
                confirmButtonText: '确定',
            });
        };
        this.service.delete(params)
            .then(function (res) {
            if (res.data.code === 85) {
                return handleErr(res);
            }
            _this.$message.success('操作成功');
            _this.getList();
        }, function (err) {
            console.log('err>>>', err);
            _this.$message.error(err.message || err.msg || '操作失败');
        });
    };
    PurSorting.prototype.addCustomer = function () {
        this.dialogTitle = "添加岗位";
        this.resetDeductionForm();
        this.handleDeduction = true;
    };
    PurSorting.prototype.resetDeductionForm = function () {
        this.deductionForm = {
            powerName: "",
            remark: "",
        };
    };
    PurSorting.prototype.submitForm = function (data) {
        var _this = this;
        if (!this.deductionForm.powerName) {
            this.$message.error("请输入岗位名称！");
        }
        else {
            console.log(this.deductionForm);
            var loadingInstance_1 = Loading.service({ fullscreen: true });
            var serviceName_1 = this.dialogTitle == "编辑岗位" ? "update" : "create";
            this.service[serviceName_1]({
                supplier_role_id: this.selectData ? this.selectData.supplier_role_id : null,
                supplier_role_name: this.deductionForm.powerName,
                comment: this.deductionForm.remark
            }).then(function (res) {
                if (res.data.success) {
                    _this.$message.success(serviceName_1 == "create" ? "添加成功！" : "修改成功");
                    loadingInstance_1.close();
                }
                else {
                    _this.$message.error(serviceName_1 == "create" ? "添加失败！" : "修改失败");
                }
                _this.getList();
            }).catch(function (err) {
                loadingInstance_1.close();
                _this.$message.error(err.message || err.msg);
            });
            this.selectData = null;
            this.handleDeduction = false;
        }
    };
    PurSorting.prototype.rowOrderDataSet = function (data) {
        this.deductionForm = {
            powerName: data.supplier_role_name,
            remark: data.comment,
        };
        this.selectData = data;
    };
    PurSorting.prototype.editOrder = function (data) {
        this.dialogTitle = "编辑岗位";
        this.rowOrderDataSet(data);
        this.handleDeduction = true;
    };
    PurSorting.prototype.authSet = function (data) {
        sessionStorage.setItem("clickRoleId", JSON.stringify(data));
        this.rowData = data;
        this.$refs.auth.showRelease();
    };
    PurSorting.prototype.search = function () {
        this.$refs.pagination.clear();
        this.getList();
    };
    PurSorting.prototype.getOrganDepot = function (params) {
        var _this = this;
        params = params ? params : {
            type: 1
        };
        this.commonService.getShopFilter(params).then(function (res) {
            if (res.data.success) {
                var depot = Array.isArray(res.data.data) ? res.data.data : [];
                _this.organBusiness = depot;
                console.log(_this.organBusiness);
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    PurSorting.prototype.normalizer = function (node) {
        return {
            id: node.id,
            label: node.name,
            children: node.children,
        };
    };
    PurSorting.prototype.shopSelect = function (node) {
        this.formData.shop = node.shop_contact;
    };
    PurSorting.prototype.shopSelectDeduction = function (node) {
        for (var i = 0; i < this.organBusiness.length; i++) {
            var data = this.organBusiness[i];
            for (var j = 0; j < data.children.length; j++) {
                if (data.children[j].id == node.id) {
                    this.moneyForm.business = data.id;
                    return;
                }
            }
        }
    };
    PurSorting.prototype.shopSelectRecharge = function (node) {
        for (var i = 0; i < this.organBusiness.length; i++) {
            var data = this.organBusiness[i];
            for (var j = 0; j < data.children.length; j++) {
                if (data.children[j].id == node.id) {
                    this.deductionForm.business = data.id;
                    return;
                }
            }
        }
    };
    PurSorting.prototype.getList = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        if (this.isMoreSearch) {
            this.isMoreSearch = false;
        }
        ;
        console.log(this.shopCode, "shopCode");
        var params = {
            keyword: "",
            is_not_in: "",
            shop_id: "",
            status: "",
            account_status: "",
        };
        Object.assign(params, pager);
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getList(params).then(function (res) {
            var data = res.data.data;
            _this.tableData = data;
            _this.total = res.data.total;
            loadingInstance.close();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    PurSorting.prototype.pageChange = function (pager) {
        this.getList();
    };
    PurSorting.prototype.sortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        if (!prop) {
            this.order = null;
        }
        else {
            this.order = [prop, order === 'ascending' ? 'asc' : 'desc'];
        }
        this.getList();
    };
    PurSorting.prototype.selectionChange = function (val) {
        this.selectedData = val;
    };
    PurSorting.prototype.searchClick = function () {
        this.$refs.pagination.clear();
        this.getList();
    };
    PurSorting.prototype.getSelectIds = function () {
        var orderIds = this.selectedData.map(function (item) { return item.order_id; });
        return orderIds;
    };
    PurSorting = __decorate([
        Component({
            components: {
                'pagination': Pagination,
                "areaShop": AreaShop,
                'auth': Auth,
            },
            methods: __assign({}, mapActions(["updateMenuList", "getAuth"])),
            computed: __assign({}, mapGetters({
                "user": "user",
                "serviceData": 'serviceData',
                "serviceDataList": 'serviceDataList'
            }))
        })
    ], PurSorting);
    return PurSorting;
}(Vue));
export default PurSorting;
